import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-square"><rect x="3" y="3" width="18" height="18" rx="0.75" fill="currentColor"/></CentralIconBase>;
};

export default IconFormSquare;
